import React from 'react';
import { images } from '../../assets';
import './HowItWorks.css';
import connectSvg from '../../assets/images/connect.svg';
import healSvg from '../../assets/images/heal.svg';
import trackSvg from '../../assets/images/track.svg';
import FadeInSection from '../FadeInSection/FadeInSection';

const HowItWorks: React.FC = () => {
  return (
    <section className="how-it-works-section">
      <img 
        src={images.howItWorks} 
        alt="How It Works Background" 
        className="how-it-works-bg"
      />
      <div className="how-it-works-content">
        <FadeInSection>
          <h2 className="how-it-works-title">How Heal improves longevity through music, HRV & breathwork</h2>
        </FadeInSection>
        <div className="how-it-works-steps">
          <FadeInSection delay={700}>
            <div className="step">
              <img src={connectSvg} alt="Connect" className="step-icon" />
              <h3>Adapts to your emotions in real-time</h3>
              <p>Sync your Apple Watch or Whoop to track your live biometrics and stress response.</p>
            </div>
          </FadeInSection>
          <FadeInSection delay={800}>
            <div className="step">
              <img src={healSvg} alt="Heal" className="step-icon" />
              <h3>Music Therapy + Breathwork</h3>
              <p>Connect your streaming service for personalised music therapy, or guided breathwork for what you need in the moment.</p>
            </div>
          </FadeInSection>
          <FadeInSection delay={900}>
            <div className="step">
              <img src={trackSvg} alt="Track" className="step-icon" />
              <h3>See the shift in real-time</h3>
              <p>Heal tracks your HRV in real-time. Watch your nervous system shift from stress to recovery.</p>
            </div>
          </FadeInSection>
        </div>
        <a
          href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
          target="_blank"
          rel="noopener noreferrer"
          className="how-it-works-cta-link"
          aria-label="Try Heal for free on the App Store"
        >
          <picture>
            <source srcSet={require('../../assets/images/CTA.png')} media="(max-width: 768px)" />
            <img 
              src={images.cta} 
              alt="Try Heal for free" 
              className="cta"
            />
          </picture>
        </a>
      </div>
    </section>
  );
};

export default HowItWorks; 